// Action Types
export const SET_NEWS_LIST_CONTENT = 'SET_NEWS_LIST_CONTENT';
export const SET_NEWS_LIST_LOADING = 'SET_NEWS_LIST_LOADING';

// Action Creator
const NewsListActionCreator = {
  setNewsListContent(details: any) {
    return {
      type: SET_NEWS_LIST_CONTENT,
      payload: {
        ...details
      }
    };
  },
  setNewsListLoading(loading: boolean) {
    return {
      type: SET_NEWS_LIST_LOADING,
      payload: {
        loading
      }
    };
  }
};

export default NewsListActionCreator;
